import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';
const LanguageContext = createContext(undefined);
export function LanguageProvider({ children }) {
    const [language, setLanguageState] = useState('es'); // Default to Spanish
    // Load language from localStorage on mount
    useEffect(() => {
        const savedLang = localStorage.getItem('language');
        if (savedLang && (savedLang === 'en' || savedLang === 'es')) {
            setLanguageState(savedLang);
        }
    }, []);
    // Save language to localStorage whenever it changes
    const setLanguage = (lang) => {
        setLanguageState(lang);
        localStorage.setItem('language', lang);
    };
    // Translation function with support for nested keys (e.g., 'nav.shop')
    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        for (const k of keys) {
            if (value && typeof value === 'object' && k in value) {
                value = value[k];
            }
            else {
                // If key not found, return the key itself
                return key;
            }
        }
        return typeof value === 'string' ? value : key;
    };
    return (_jsx(LanguageContext.Provider, { value: { language, setLanguage, t }, children: children }));
}
export function useLanguage() {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
}
// Alias for convenience
export const useTranslation = useLanguage;
